<template>
  <div class="inquirycenter">
    <p class="directory">
      <span @click="businesspersonalClick" class="directory_home">个人中心
      </span>
      > 询盘中心
    </p>
    <div class="inquirycenter_main">
      <!-- <div class="button">
        <el-button
          type="primary"
          v-for="(item, index) in statusBtn"
          :key="index"
          @click="statusFun(index)"
          >{{ item }}</el-button
        >
      </div> -->
      <div v-if="isPc">
        <el-table :data="tableList" border style="width: 100%; margin: 20px 0" :header-cell-style="headStyle"
          :cell-style="headStyle" class="eltable">
          <el-table-column prop="id" label="编号" width="60"> </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="120">
          </el-table-column>
          <el-table-column prop="status" label="状态" width="90">
            <template slot-scope="scope">
              <div>
                <span>{{
                  scope.row.status == 0
                  ? "审核中"
                  : scope.row.status == 1
                  ? "通过"
                  : "未通过"
                  }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="电话" width="120">
          </el-table-column>
          <el-table-column prop="email" label="邮箱" width="170">
          </el-table-column>
          <el-table-column prop="message" label="备注" width="120">
          </el-table-column>
          <el-table-column prop="commodityId" label="商品id" width="120">
          </el-table-column>
          <el-table-column prop="quantity" label="购买数量" width="120">
          </el-table-column>
          <el-table-column prop="commodityName" label="商品名称" width="120">
          </el-table-column>
          <el-table-column prop="commodityTitle" label="商品副名称" width="120">
          </el-table-column>
          <el-table-column prop="categoryName" label="商品分类" width="120">
          </el-table-column>
          <el-table-column prop="specifications" label="商品规格" width="120">
          </el-table-column>
          <el-table-column prop="image" label="图片" width="120">
            <template slot-scope="scope">
              <img alt="图片" :src="$baseUrl + scope.row.image"   @click="previewPic(scope.row.image)"
                style="width: 50px; height: 50px" />
            </template>
          </el-table-column>
          <el-table-column prop="originalPrice" label="原价" width="120">
          </el-table-column>
          <el-table-column prop="presentPrice" label="现价" width="120">
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <!-- <el-button type="text" size="small" @click="updateClick(scope.row)">修改</el-button> -->
              <el-button v-if="scope.row.status == 1" @click="handleClick(scope.row)" type="text"
                size="small">查看订单</el-button>
              <el-button type="text" size="small" @click="examine(scope.row)"
                v-if="scope.row.status == 0">审核</el-button>
              <!-- <el-button type="text" size="small">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-pagination align="center" background @current-change="handleCurrentChange" :current-page="form.pageNum"
            :page-size="form.pageSize" layout="total, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>

        <!-- PC -->
        <!-- 图片预览 -->
        <el-dialog :visible.sync="dialogVisible" :modal="false" title="图片预览" width="50%">
          <img alt="图片" :src="dialogVisibleUrl"   width="100%" />
        </el-dialog>
        <!-- 修改订单状态 -->
        <el-dialog title="修改订单状态" :visible.sync="updateOrderVisible">
          <div>
            <span style="margin-right: 20px">状态</span>
            <el-radio-group v-model="OrderRadio">
              <el-radio label="已支付" value="1" v-if="OrderInfo.status == 0"></el-radio>
              <el-radio label="已发货" value="2" v-if="OrderInfo.status == 1"></el-radio>
              <el-radio label="已完成" value="3" v-if="OrderInfo.status == 2"></el-radio>
            </el-radio-group>
            <div style="text-align: end">
              <el-button type="primary" @click="orderFun(OrderRadio)">确定</el-button>
            </div>
          </div>
        </el-dialog>
        <!-- 查看询盘订单 -->
        <el-dialog title="询盘订单" :visible.sync="orderVisible" width="80%">
          <el-table :data="orderList" style="width: 100%" :header-cell-style="headStyle" :cell-style="headStyle">
            <el-table-column prop="id" label="ID" width="120"> </el-table-column>
            <el-table-column prop="commodityName" label="商品名称" width="120">
            </el-table-column>
            <el-table-column prop="specifications" label="商品规格" width="120">
            </el-table-column>
            <el-table-column label="订单状态">
              <template slot-scope="scope">
                <span>{{
                  scope.row.status == 0
                  ? "未支付"
                  : scope.row.status == 1
                  ? "已支付"
                  : scope.row.status == 2
                  ? "已发货"
                  : "已完成"
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="unitPrice" label="单价" width="120">
            </el-table-column>
            <el-table-column prop="quantity" label="购买数量" width="120">
            </el-table-column>
            <el-table-column prop="businessEmail" label="回件商家邮箱" width="120">
            </el-table-column>
            <el-table-column prop="totalPrice" label="总价" width="120">
            </el-table-column>
            <el-table-column prop="collectionType" label="收款方式" width="120">
              <template slot-scope="scope">
                <span>{{
                  scope.row.collectionType == 1 ? "二维码" : "银行卡"
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="collectionQrcode" label="收款码地址" width="120">
              <template slot-scope="scope">
                <img alt="图片" :src="scope.row.collectionQrcode"   class="collectionQrcode_img" />
              </template>
            </el-table-column>
            <el-table-column prop="beneficiaryName" label="受益人姓名" width="120">
            </el-table-column>
            <el-table-column prop="beneficiaryAddress" label="受益人地址" width="120">
            </el-table-column>
            <el-table-column prop="beneficiaryAccNo" label="受益人账号" width="120">
            </el-table-column>
            <el-table-column prop="addressOfBank" label="银行地址" width="120">
            </el-table-column>
            <el-table-column prop="swiftCode" label="SWIFT码" width="120">
            </el-table-column>
            <el-table-column prop="postCode" label="邮政编码" width="120">
            </el-table-column>
            <el-table-column prop="tel" label="电话" width="120">
            </el-table-column>
            <el-table-column prop="customDefinition" label="自定义字段" width="120">
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button @click="updateOrder(scope.row)" type="text" size="small"
                  v-if="scope.row.status != 3">修改</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-dialog>
        <!-- 审核询盘 -->
        <el-dialog title="审核" :visible.sync="examineVisible" class="shenhe">
          <el-descriptions title="审核信息">
            <el-descriptions-item label="编号">{{
              examineList.id
              }}</el-descriptions-item>
            <el-descriptions-item label="创建时间">{{
              examineList.createTime
              }}</el-descriptions-item>
            <el-descriptions-item label="状态">{{
              examineList.status == 0
              ? "审核中"
              : examineList.status == 1
              ? "通过"
              : "未通过"
              }}</el-descriptions-item>
            <el-descriptions-item label="电话">{{
              examineList.phone
              }}</el-descriptions-item>
            <el-descriptions-item label="邮箱">{{
              examineList.email
              }}</el-descriptions-item>
            <el-descriptions-item label="备注">{{
              examineList.message
              }}</el-descriptions-item>
            <el-descriptions-item label="商品id">{{
              examineList.commodityId
              }}</el-descriptions-item>
            <el-descriptions-item label="购买数量">{{
              examineList.quantity
              }}</el-descriptions-item>
            <el-descriptions-item label="商品名称">{{
              examineList.commodityName
              }}</el-descriptions-item>
            <el-descriptions-item label="商品副名称">{{
              examineList.commodityTitle
              }}</el-descriptions-item>
            <el-descriptions-item label="商品分类">{{
              examineList.categoryName
              }}</el-descriptions-item>
            <el-descriptions-item label="商品规格">{{
              examineList.specifications
              }}</el-descriptions-item>
            <el-descriptions-item label="图片">
              <template>
                <img alt="图片" :src="$baseUrl + examineList.image"   style="width: 50px; height: 50px" />
              </template>
            </el-descriptions-item>
            <el-descriptions-item label="原价">{{
              examineList.originalPrice
              }}</el-descriptions-item>
            <el-descriptions-item label="现价">{{
              examineList.presentPrice
              }}</el-descriptions-item>
          </el-descriptions>
          <el-form :model="formList">
            <el-form-item label="状态">
              <el-select v-model="formList.status" placeholder="请选择状态">
                <el-option v-for="(item, index) in exmineStatus" :key="index" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <div v-if="formList.status == 1">
              <el-form-item label="收件人邮箱" style="display: flex">
                <el-input v-model="formList.toUser" placeholder="请输入收件人邮箱"></el-input>
                <div class="titel">(此处可修改询盘用户正确邮箱)</div>
              </el-form-item>
              <el-form-item label="商品名称" style="display: flex">
                <el-input v-model="formList.commodityName" placeholder="请输入商品名称"></el-input>
              </el-form-item>
              <el-form-item label="商品规格" style="display: flex">
                <el-input v-model="formList.specifications" placeholder="请输入商品规格"></el-input>
              </el-form-item>
              <el-form-item label="单价" style="display: flex">
                <el-input v-model="formList.unitPrice" placeholder="请输入单价"></el-input>
              </el-form-item>
              <el-form-item label="购买数量" style="display: flex">
                <el-input v-model="formList.quantity" placeholder="请输入购买数量"></el-input>
              </el-form-item>
              <el-form-item label="回件商家邮箱" style="display: flex">
                <el-input v-model="formList.businessEmail" placeholder="请输入回件商家邮箱"></el-input>
              </el-form-item>
              <el-form-item label="总价" style="display: flex">
                <el-input v-model="formList.totalPrice" placeholder="请输入总价"></el-input>
              </el-form-item>
              <el-form-item label="收款方式">
                <el-radio-group v-model="formList.collectionType">
                  <el-radio label="1">二维码</el-radio>
                  <el-radio label="2">银行卡</el-radio>
                </el-radio-group>
              </el-form-item>
              <div v-if="formList.collectionType == 1">
                <el-form-item label="收款码地址">
                  <el-upload :action="this.$baseUrl + '/other/upload'" :before-upload="handleBeforeUpload"
                    list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleRemove"
                    :on-exceed="hadleExceed" :on-success="handelSuccess" :limit="1" name="file">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="exmineImageVisible">
                    <img alt="图片" width="100%" :src="exmineImageImageUrl"   />
                  </el-dialog>
                </el-form-item>
              </div>
              <div v-if="formList.collectionType == 2">
                <el-form-item label="受益人姓名" style="display: flex">
                  <el-input v-model="formList.beneficiaryName" placeholder="请输入受益人姓名"></el-input>
                </el-form-item>
                <el-form-item label="受益人地址" style="display: flex">
                  <el-input v-model="formList.beneficiaryAddress" placeholder="请输入受益人地址"></el-input>
                </el-form-item>
                <el-form-item label="受益人账号" style="display: flex">
                  <el-input v-model="formList.beneficiaryAccNo" placeholder="请输入受益人账号"></el-input>
                </el-form-item>
                <el-form-item label="银行地址" style="display: flex">
                  <el-input v-model="formList.addressOfBank" placeholder="请输入银行地址"></el-input>
                </el-form-item>
                <el-form-item label="SWIFT码" style="display: flex">
                  <el-input v-model="formList.swiftCode" placeholder="请输入SWIFT码"></el-input>
                </el-form-item>
                <el-form-item label="邮政编码" style="display: flex">
                  <el-input v-model="formList.postCode" placeholder="请输入邮政编码"></el-input>
                </el-form-item>
                <el-form-item label="受益人银行" style="display: flex">
                  <el-input v-model="formList.beneficiaryBank" placeholder="请输入受益人银行"></el-input>
                </el-form-item>
                <el-form-item label="电话" style="display: flex">
                  <el-input v-model="formList.tel" placeholder="请输入电话"></el-input>
                </el-form-item>
                <el-form-item label="自定义字段" style="display: flex">
                  <div style="width: 600px; border: 1px solid #ccc">
                    <client-only>
                      <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig"
                        :mode="mode" />
                      <Editor style="height: 500px; overflow-y: hidden" v-model="formList.customDefinition"
                        :defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated" />
                    </client-only>
                  </div>
                </el-form-item>
              </div>
            </div>
            <div style="text-align: center">
              <el-button type="primary" @click="submitFun(formList)">提交审核</el-button>
            </div>
          </el-form>
        </el-dialog>
      </div>
      <div class="yd_qiquirycenter_main" v-else>
        <div class="yd_main_top">
          <div class="yd_main_top_tital">
            询盘中心
          </div>
        </div>
        <div class="yd_main_top_list">
          <div class="yd_main_top_list_page" v-for="(item, index) in tableList" :key="index">
            <div class="product-card">
              <!-- 购买数量和价格 -->
              <div class="product-price-quantity">
                <span class="quantity">创建时间：{{ item.createTime }}</span>
                <span class="price">编号：{{ item.id }}</span>
              </div>
              <!-- 上方对齐部分：图片 + 基本信息 -->
              <div class="product-top-section">
                <!-- 左侧商品图片 -->
                <div class="product-image">
                  <img :src="$baseUrl + item.image" @click="previewPic(item.image)" alt="商品图片">
                </div>

                <!-- 右侧商品基本信息 -->
                <div class="product-basic-info">
                  <!-- 商品名称（限制两行显示） -->
                  <div class="product-name">{{ item.commodityName }}</div>

                  <!-- 商品分类 -->
                  <div class="product-category">商品分类：{{ item.categoryName }}</div>

                  <!-- 规格 -->
                  <div class="product-spec">规格：{{ item.specifications }}</div>
                </div>
              </div>

              <!-- 下方其他信息 -->
              <div class="product-bottom-section">
                <!-- 购买数量和价格 -->
                <div class="product-price-quantity">
                  <span class="quantity">购买数量：{{ item.quantity }}</span>
                  <span class="price">现价：¥{{ item.presentPrice ? item.presentPrice : 0 }}</span>
                </div>

                <!-- 邮箱 -->
                <div class="product-email">邮箱：{{ item.email }}</div>

                <!-- 备注 -->
                <div class="product-remark">备注：{{ item.message }}</div>

                <!-- 审核状态和按钮 -->
                <div class="product-footer">
                  <div class="product-status">
                    审核状态：{{
                    item.status == 0
                    ? "审核中"
                    : item.status == 1
                    ? "通过"
                    : "未通过"
                    }}
                  </div>
                  <button class="action-btn" v-if="item.status == 0" @click="ydShenHeShow(item)">审核</button>
                  <button class="action-btn" v-if="item.status == 1"
                    @click="ydXpOrderShow(item?.orderVos)">查看订单</button>
                </div>
              </div>
            </div>
          </div>
          <div>
            <!-- <el-pagination align="center" background @current-change="handleCurrentChange" :current-page="form.pageNum"
              :page-size="form.pageSize" layout="total, prev, pager, next, jumper" :total="total">
            </el-pagination> -->
            <MobilePagination :current-page="form.pageNum" :total-items="total" :items-per-page="form.pageSize"
              @page-changed="handleCurrentChange" />
          </div>
        </div>

        <!-- 移动端 -->
        <!-- 审核 -->
        <AuditDialog :visible.sync="auditShowDialog" :product="examineList" @confirm="ydShenHehandleConfirm" />
        <!-- 查看订单 -->
        <InquiryOrderModal :visible="isModalVisible" :orderData="orderList" @close="isModalVisible = false" />
      </div>

    </div>
  </div>
</template>

<script>
  import {
    shopEnquiriesList,
    shopEnquiriesStatus,
    modifyEnquiriesOrder,
  } from "@/api/business";
  import { lazyWangeditor } from "@/utils/lazy-editor";
  import { upload } from "@/api/other";
  import MobilePagination from '@/components/MobilePagination/MobilePagination';
  import AuditDialog from '@/components/inquiryCenter/AuditDialog';
  import InquiryOrderModal from '@/components/inquiryCenter/InquiryOrderModal';

  export default {
    name: "Inquirycenter",
    async asyncData() {
      const res = await shopEnquiriesList({ pageNum: 1, pageSize: 5 }).catch(() => ({ code: -1 }))
      return {
        tableList: res.code === 200 ? res.data.vos : [],
        total: res.code === 200 ? res.data.total : 0
      }
    },
    data() {
      return {
        statusBtn: ["审核中", "通过", "未通过"],
        editor: null,
        toolbarConfig: {},

        editorConfig: {
          placeholder: "请输入内容...",
          MENU_CONF: {
            //配置上传图片
            uploadImage: {
              customUpload: this.uploadImg,
            },
          },
        },
        mode: "default", // or 'simple'
        tableList: [],
        total: 0,
        form: {
          pageNum: 1,
          pageSize: 5,
          businessId: sessionStorage.getItem("businessId"),
          status: null,
        },
        dialogVisible: false,
        dialogVisibleUrl: "",
        updateOrderVisible: false,
        orderList: [],
        orderVisible: false,
        examineVisible: false,
        examineList: {},
        formList: {
          id: null,
          status: null,
          toUser: "",
          commodityName: "",
          specifications: "",
          unitPrice: null,
          quantity: null,
          businessEmail: "",
          totalPrice: null,
          collectionType: null,
          collectionQrcode: "",
          beneficiaryName: "",
          beneficiaryAddress: "",
          beneficiaryAccNo: "",
          addressOfBank: "",
          swiftCode: "",
          beneficiaryBank: "",
          postCode: "",
          tel: "",
          customDefinition: "",
        },
        exmineStatus: [
          {
            value: 1,
            label: "通过",
          },
          {
            value: 2,
            label: "未通过",
          },
        ],
        exmineImageVisible: false,
        exmineImageImageUrl: "",
        OrderRadio: 3,
        OrderInfo: {
          id: null,
          status: null,
        },
        isPc: true,

        //移动端
        auditShowDialog: false,
        isModalVisible: false,
      };
    },
    components: {
      // @wangeditor 在 Node 中 import 即抛 Element is not defined,
      // 用共享工厂:客户端懒加载真组件,服务端渲染空占位
      Editor: lazyWangeditor("Editor"),
      Toolbar: lazyWangeditor("Toolbar"),
      MobilePagination,
      AuditDialog,
      InquiryOrderModal,
    },
    mounted() {
      if (document.documentElement.clientWidth > 1080) {
        this.isPc = true;
        this.form.pageSize = 5;
        this.shopEnquiriesList();
      } else {
        this.isPc = false;
        this.form.pageSize = 2;
      }
      // 屏幕变化
      window.addEventListener("resize", () => {
        if (document.documentElement.clientWidth > 1080) {
          this.isPc = true;
          this.form.pageSize = 5;
          this.shopEnquiriesList();
        } else {
          this.isPc = false;
          this.form.pageSize = 2;
          this.shopEnquiriesList();
        }
      });
      this.shopEnquiriesList();
    },

    methods: {
      ydShenHeShow(commodityInfo) {
        this.auditShowDialog = true;
        this.examineList = commodityInfo;
        this.formList.id = commodityInfo.id;
      },
      ydShenHehandleConfirm(auditData) {
        console.log('审核数据:', auditData);
        // 提交审核逻辑
        this.submitFun(auditData);
      },
      ydXpOrderShow(xpOrderList) {
        this.isModalVisible = true;
        this.orderList = xpOrderList;
      },
      //判断图片大小
      handleBeforeUpload(file) {
        // 检查文件类型是否为图片
        const isImage = file.type.startsWith('image/');
        if (!isImage) {
          this.$message.error('只能上传图片类型的文件！');
          return false;
        }
        if (this.$maxImgSize) {
          //转化为kb
          const isLt = file.size / 1024 < this.$maxImgSize;
          if (!isLt) {
            this.$message.error(`上传的图片最大不能超过 ${this.$maxImgSize} KB!`);
            return false;
          }
        }
      },
      businesspersonalClick() {
        this.$router.push({
          path: "/businesspersonal/businessessential",
          query: {
            noBusiness: false,
            isbottomnav: false,
          },
        });
      },
      statusFun(e) {
        this.form.status = e;
        this.shopEnquiriesList();
      },
      // 提交审核
      submitFun(e) {
        shopEnquiriesStatus({ ...e }).then((res) => {
          if (res.code == 200) {
            this.$message({ message: "操作成功", type: "success" });
            this.examineVisible = false;
            this.shopEnquiriesList();
          } else if (res.code == 401) {
            this.$message({ message: res.msg, type: "error" });
            this.$router.push({
              path: "/login",
              query: {
                box8: false,
                phoneHomeImg: false,
                bool: false,
              },
            });
          } else {
            this.$message({ message: res.msg, type: "error" });
          }
        });
      },
      handelSuccess(response) {
        if (response.code == 200) {
          this.formList.collectionQrcode =
            this.$baseUrl + response.data.relativeUrl;
          this.$message({
            message: "上传成功",
            type: "success",
          });
        } else if (response.code == 401) {
          this.$message({ message: response.msg, type: "error" });
          //未登录
          this.$router.push({
            path: "/login",
            query: {
              box8: false,
              phoneHomeImg: false,
              bool: false,
            },
          });
        } else {
          this.$message({ message: response.msg, type: "error" });
        }
      },
      handleRemove() {
        this.formList.collectionQrcode = "";
      },
      hadleExceed(files, fileList) {
        this.$message({
          message: "最多只能上传一张图片",
          type: "error",
        });
      },
      handlePictureCardPreview(file) {
        this.exmineImageVisible = file.url;
        this.examineVisible = true;
      },
      //获取数据
      shopEnquiriesList() {
        shopEnquiriesList({ ...this.form }).then((res) => {
          this.tableList = res.data.vos;
          this.total = res.data.total;
        });
      },
      //订单修改状态
      updateOrder(e) {
        this.updateOrderVisible = true;
        this.OrderInfo.id = e.id;
        this.OrderInfo.status = e.status;
      },
      //表格每行点击
      handleClick(e) {
        this.orderList = e.orderVos;
        this.orderVisible = true;
      },
      //打开审核弹框
      examine(e) {
        this.examineVisible = true;
        this.examineList = e;
        this.formList.id = e.id;
      },
      //表格图片预览
      previewPic(url) {
        this.dialogVisibleUrl = this.$baseUrl + url;
        this.dialogVisible = true;
      },
      //修改订单状态
      orderFun(e) {
        let status = null;
        if (e == "已支付") {
          status = 1;
        }
        if (e == "已发货") {
          status = 2;
        }
        if (e == "已完成") {
          status = 3;
        }
        this.$alert("是否执行此操作", {
          confirmButtonText: "确定",
          showCancelButton: true,
        })
          .then(() => {
            modifyEnquiriesOrder(this.OrderInfo.id, status).then((res) => {
              if (res.code == 200) {
                this.$message({ message: "操作成功", type: "success" });
                this.shopEnquiriesList();
                this.updateOrderVisible = false;
                this.orderVisible = false;
              } else {
                this.$message({ message: res.msg, type: "error" });
                this.updateOrderVisible = false;
              }
            });
          })
          .catch(() => { });
      },
      //改变页数
      handleCurrentChange(e) {
        this.form.pageNum = e;
        this.shopEnquiriesList();
      },
      //表格内容居中
      headStyle() {
        return "text-align:center";
      },
      onCreated(editor) {
        this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
      },
      uploadImg(file, insertFn) {
        let imgData = new FormData();
        imgData.append("file", file);
        //调接口，上传图片
        upload(imgData)
          .then((response) => {
            insertFn(this.$baseUrl + response.data.relativeUrl);
          })
          .catch(() => {
            this.$message("上传图片失败");
          });
      },
    },
  };
</script>

<style scoped>
  .inquirycenter {
    width: 100vw;
    /* padding: 20px; */

    border-top: 2px solid #ddd;
  }

  .directory {
    background-color: #f1f1f1;
    margin: 0;
    font-size: 0.93vw;
    font-family: Roboto;
    font-weight: 400;
    color: #999999;
    padding: 1vw 5vw;
  }

  .inquirycenter_main {
    width: 90%;
    margin: 20px auto;
    min-height: 70vh;
  }

  .titel {
    font-size: calc(18 * 100vw / 1920);
    color: rgb(174, 173, 173);
    line-height: calc(25 * 100vw / 1920);
    margin-top: 5px;
  }

  .collectionQrcode_img {
    max-height: calc(300 * 100vw / 1920);
  }

  @media screen and (max-width: 1080px) {
    .collectionQrcode_img {
      max-height: calc(450 * 100vw / 1080);
    }

    .inquirycenter {
      width: 100vw;
      min-height: 60vh;
    }

    .directory {
      display: none;
    }

    .inquirycenter_main {
      width: 100%;
      margin: 20px auto;
      min-height: 80vh;
    }

    .titel {
      font-size: calc(35 * 100vw / 1080);
      color: rgb(174, 173, 173);
      line-height: calc(0 * 100vw / 1080);
      margin-top: 11px;
    }

    .inquirycenter .button {
      display: flex;
      justify-content: center;
    }

    .eltable {
      font-size: calc(40 * 100vw / 1080);
    }

    ::v-deep .el-dialog {
      width: 90vw !important;
    }

    ::v-deep .el-descriptions__body .el-descriptions__table .el-descriptions-item__cell,
    .el-form-item {
      display: flex;
    }


    .yd_main_top {
      width: 100%;
      height: 10.55556vw;
      background-color: #fff;
      border-bottom: .09259vw solid #f0efef;
      padding-top: 2.96296vw;
    }

    .yd_main_top_tital {
      margin-left: 3.7037vw;
      width: 25.92593vw;
      height: 7.59259vw;
      line-height: 7.59259vw;
      white-space: nowrap;
      border-bottom: .55556vw solid #13af87;
      font-weight: bolder;
      font-size: 4.33333vw;
      margin-bottom: 2.96296vw;
    }

    /* 询盘整体卡片样式 */
    .product-card {
      margin: 3.7037vw;
      padding: 8px;
      margin-bottom: 16px;
      border-radius: 8px;
      background-color: #fff;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      border: 1px solid #13af87;
    }

    /* 上方对齐部分 */
    .product-top-section {
      display: flex;
      margin-bottom: 12px;
    }

    /* 商品图片样式 */
    /* 商品图片容器 */
    .product-image {
      width: 100px;
      height: 100px;
      margin-right: 16px;
      flex-shrink: 0;
      cursor: pointer;
      overflow: hidden;
      /* 隐藏超出部分 */
      position: relative;
      /* 为绝对定位图片做准备 */
      border-radius: 4px;
      /* 可选：添加圆角 */
    }

    /* 图片样式 - 填满容器且保持比例 */
    .product-image img {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
      /* 关键属性：填充整个容器，保持比例 */
      top: 0;
      left: 0;
    }

    /* 右侧商品基本信息 */
    .product-basic-info {
      flex: 1;
      min-width: 0;
      /* 防止flex内容溢出 */
    }

    /* 商品名称 - 限制两行显示 */
    .product-name {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 8px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 1.4;
    }

    /* 商品分类 - 限制一行显示 */
    .product-category {
      margin-bottom: 6px;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #666;
    }

    /* 规格信息 */
    .product-spec {
      margin-bottom: 6px;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #666;
    }

    /* 下方其他信息 */
    /* .product-bottom-section {
      margin-left: 116px;
    } */

    /* 价格和数量 */
    .product-price-quantity {
      display: flex;
      justify-content: space-between;
      margin-bottom: 6px;
    }

    .quantity {
      color: #666;
    }

    .price {
      color: #f56c6c;
      font-weight: bold;
    }

    /* 邮箱 */
    .product-email {
      margin-bottom: 6px;
      color: #666;
    }

    /* 备注 - 限制一行显示 */
    .product-remark {
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 6px;
      color: #666;
    }

    /* 底部状态和按钮 */
    .product-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 8px;
    }

    .product-status {
      color: #13af87;
    }

    /* 操作按钮 */
    .action-btn {
      padding: 6px 12px;
      background-color: #13af87;
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-size: 14px;
      transition: background-color 0.3s;
    }

    .action-btn:hover {
      background-color: #4fe0bc;
    }

  }
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style>
  .inquirycenter .el-form-item__label {
    width: calc(180 * 100vw / 1920);
    text-align: left;
  }

  @media screen and (max-width: 1080px) {
    .inquirycenter .el-form-item__label {
      width: calc(219 * 100vw / 1080);
      text-align: left;
      font-size: calc(36 * 100vw / 1080);
      line-height: calc(50 * 100vw / 1080);
      display: flex;
      align-items: center;
    }
  }
</style>